module.exports = __webpack_public_path__ + "static/gigs-side-image-36f39abccaeb2021f44ea45fad2bb020.jpg";